// Payment dialogs must only close from their own close icon or buttons,
// never from a stray click on the backdrop or the Esc key.
export const lockedClose = (onClose) => (event, reason) => {
  if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
  if (onClose) onClose(event, reason);
};
